import TenderPrint from './TenderPrint';

export default TenderPrint;
